import React from 'react';
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { nativeInputSx } from '../common/formFieldStyles';
import { formatCurrency } from '../../utils/currencyUtils';
import { formatStockQuantity } from '../../utils/stockQuantityUtils';
import { getStockStatus } from '../../utils/stockStatusUtils';
import { BRAND } from '../../theme/brandTokens';

const StockOverviewPanel = ({
  items = [],
  totalCount = 0,
  page,
  pageSize,
  search,
  onSearchChange,
  onPageChange,
  canSeeCosts = false,
  currency,
}) => {
  const { t } = useTranslation();

  return (
    <Box id="stock-overview-panel" sx={{ p: { xs: 2, sm: 3 } }}>
      <Box
        component="input"
        id="stock-overview-search"
        type="search"
        aria-label={t('stock.overview.search')}
        placeholder={t('stock.overview.search')}
        value={search}
        onChange={(event) => onSearchChange(event.target.value)}
        sx={{ ...nativeInputSx(false), mb: 2, maxWidth: 360 }}
      />
      <Box sx={{ overflowX: 'auto', border: `1px solid ${BRAND.line}`, borderRadius: 2 }}>
        <Table size="small">
          <TableHead>
            <TableRow sx={{ backgroundColor: BRAND.background }}>
              <TableCell>{t('stock.overview.product')}</TableCell>
              <TableCell>{t('stock.overview.onHand')}</TableCell>
              <TableCell>{t('stock.overview.status')}</TableCell>
              {canSeeCosts ? <TableCell align="right">{t('stock.overview.lastCost')}</TableCell> : null}
            </TableRow>
          </TableHead>
          <TableBody>
            {items.length === 0 ? (
              <TableRow>
                <TableCell colSpan={canSeeCosts ? 4 : 3}>
                  <Typography variant="body2" color="text.secondary">{t('stock.overview.empty')}</Typography>
                </TableCell>
              </TableRow>
            ) : items.map((item) => {
              const status = item.isLow ? 'low' : getStockStatus(item);
              return (
                <TableRow key={item.id}>
                  <TableCell>{item.name}</TableCell>
                  <TableCell>
                    {formatStockQuantity({
                      stockOnHand: item.stockOnHand,
                      contentQuantity: item.contentQuantity,
                      stockUnit: item.stockUnit,
                    })}
                  </TableCell>
                  <TableCell>{t(`stock.status.${status}`)}</TableCell>
                  {canSeeCosts ? (
                    <TableCell align="right">
                      {item.lastUnitCost == null
                        ? t('stock.overview.noCost')
                        : formatCurrency(item.lastUnitCost, currency)}
                    </TableCell>
                  ) : null}
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
        <TablePagination
          component="div"
          count={totalCount}
          page={Math.max(0, page - 1)}
          onPageChange={(_, nextPage) => onPageChange(nextPage + 1)}
          rowsPerPage={pageSize}
          rowsPerPageOptions={[pageSize]}
          onRowsPerPageChange={() => {}}
        />
      </Box>
    </Box>
  );
};

export default StockOverviewPanel;
